var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.601 148h54.082c9.508-19.733-4.884-43-27.048-43-22.122 0-36.581 23.23-27.034 43z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.635 75c38.214 0 66.875 35.449 58.582 73h76.418v-33c0-5.523-4.477-10-10-10h-20.183a108.328 108.328 0 0 0-9.497-22.894l14.281-14.281c3.905-3.905 3.905-10.237 0-14.142l-28.284-28.284c-3.905-3.905-10.237-3.905-14.142 0L276.529 39.68a108.33 108.33 0 0 0-22.894-9.498V10c0-5.523-4.477-10-10-10h-40c-5.523 0-10 4.477-10 10v20.183a108.279 108.279 0 0 0-22.894 9.498L156.46 25.399c-3.905-3.905-10.237-3.905-14.142 0l-28.284 28.284c-3.905 3.905-3.905 10.237 0 14.142l14.282 14.281A108.328 108.328 0 0 0 118.819 105H98.635c-5.523 0-10 4.477-10 10v33h76.452c-8.34-37.649 20.415-73 58.548-73zM474.026 317.66l-58.87-88.03c-1.003-17.81-4.58-35.09-10.669-51.63H46.422c-33.78 91.708 12.41 197.467 109.033 231.75V497c0 8.28 6.71 15 15 15h171c8.28 0 15-6.72 15-15v-77h44c8.28 0 15-6.72 15-15v-64h46.1c11.961 0 19.131-13.38 12.471-23.34z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.29d5251816ae679110791d793b0d17ab.svg";
export { ForwardRef as ReactComponent };